/**
 * Created by jonas on 2021-02-02.
 */

export class ArrayUtils {

    public static cloneMatrix(input:any[][]):any[][] {
        const result = [];
        for (let column of input) {
            result.push([...column]);
        }

        return result;
    }

    public static isAllTrue(array:boolean[]):boolean {
        return !ArrayUtils.isAnyFalse(array);
    }

    public static isAnyFalse(array:boolean[]):boolean {
        for (let value of array) {
            if (!value) {
                return true;
            }
        }
        return false;
    }


    public static isAllFalse(array:boolean[]):boolean {
        return !ArrayUtils.isAnyTrue(array);
    }

    public static isAnyTrue(array:boolean[]):boolean {
        for (let value of array) {
            if (value) {
                return true;
            }
        }
        return false;
    }


    public static shuffleArray(array:any[]):any[] {
        let a:any[] = array.concat();
        for (let i = a.length; i; i--) {
            let j = Math.floor(Math.random() * i);
            [a[i - 1], a[j]] = [a[j], a[i - 1]];
        }
        return a;
    }


    /**
     * Removes any duplicates from array.
     * @param a
     */
    public static unique(a:any[]):any[] {
        return Array.from(new Set(a));
    }
}